<template>
	<div class="home">
		<home-banner></home-banner>
		<div class="mainer">
			<hot-deals></hot-deals>
			<recentlow-priceair @go-search="goSearch"></recentlow-priceair>
			<top-destination></top-destination>
		</div>
	</div>
</template>

<script lang="ts" setup>
import { onMounted } from 'vue';
import { setHomeScrollTopFun, setQueryParamsFun } from '@/store/home';
import { routeGo } from '@/hooks/web/jumpGo';
import { getSelectCurrency } from '@/store/locale';
import { getAirportsList, removeDashesFromDate } from '@/logic/home';
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
// @ts-ignore
definePageMeta({
	isShowSelectCurrency: true,
	isShowSelectLanguage: true,
});
onMounted(() => {
	window.addEventListener('scroll', handleScroll);
});
function handleScroll() {
	setHomeScrollTopFun(window.scrollY);
}
async function goSearch(ticketItem: any) {
	let url: string = 'flights/search/' + ticketItem.fromCityCode + '/' + ticketItem.toCityCode;
	const fromCityList: any = await getAirportsList(locale.value.toLowerCase(), ticketItem.fromCityName);
	const toCityList: any = await getAirportsList(locale.value.toLowerCase(), ticketItem.toCityName);
	let fromCityInfo: any = {};
	let toCityInfo: any = {};
	for (let i in fromCityList) {
		if (fromCityList[i].cityCode === ticketItem.fromCityCode) {
			fromCityInfo = fromCityList[i];
		}
	}
	for (let i in toCityList) {
		if (toCityList[i].cityCode === ticketItem.toCityCode) {
			toCityInfo = toCityList[i];
		}
	}
	let queryParam = {
		adults: 1,
		children: 0,
		infant: 0,
		startDate: removeDashesFromDate(ticketItem.fromDate),
		endDate: ticketItem.retDate ? removeDashesFromDate(ticketItem.retDate) : '',
		tripType: ticketItem.retDate ? 2 : 1,
		seatClass: 'E',
		currency: getSelectCurrency(),
	};
	if (queryParam.tripType === 1) {
		// @ts-ignore
		delete queryParam['endDate'];
	}
	setQueryParamsFun({
		adultNum: 1,
		childNum: 0,
		infantNum: 0,
		fromCity: {
			cityCode: ticketItem.fromCityCode,
			cityName: ticketItem.fromCityName,
		},
		toCity: {
			cityCode: ticketItem.toCityCode,
			cityName: ticketItem.toCityName,
		},
		fromDate: ticketItem.fromDate,
		retDate: ticketItem.retDate,
		cabinGrades: 'E',
		tripType: ticketItem.retDate ? 2 : 1,
		fromCityInfo: fromCityInfo,
		toCityInfo: toCityInfo,
	});
	routeGo(url, '', queryParam);
}
</script>

<style lang="scss" scoped></style>
